<template>
    <div class="page-wrap">
        <div class="page-bar">
            <div>
                <div class="page-bar-sub">Work</div>
                <div class="page-bar-main">Spreadsheets</div>
            </div>
        </div>
        <div :class="$store.state.routeLoaded ? 'slide-up view' : 'hide'">
            <div class="page-filters pf-bar">
                <div class="pf-search">
                    <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.35-4.35" /></svg>
                    <input type="text" v-model="searchQ" placeholder="Search" aria-label="Search" @input="search()" />
                </div>
                <span class="pf-spacer"></span>
                <div v-if="$store.state.user.role == 'Admin'" @click="() => { showAddSheet = true }" class="add-btn">Add</div>
            </div>
            <table class="full-table">
                <tbody>
                    <tr v-for="(sheet, i) in sheets" :key="i">
                        <td>
                            <router-link :to="'/company-sheet/' + sheet.Slug"><span v-if="sheet.Template">(TEMPLATE) </span>{{ sheet.Name }}</router-link>
                        </td>
                        <td v-if="$store.state.user.role == 'Admin'" style="text-align:center">
                            <a @click.prevent="editUsers(sheet.Slug)">Edit Users</a>
                        </td>
                        <td v-if="$store.state.user.role == 'Admin'" style="text-align:center">
                            <a v-if="sheet.Name != 'Company Scorecard'" @click.prevent="deleteSheet(sheet.Slug)">Delete</a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>

        <select-employees v-if="showEditUsers" title="Share with" source="/api/employees/picker" :selectedIds="editUsersCurrent" @save="saveUsers" @close="() => { showEditUsers = false; }" />
        <add-company-sheet v-if="showAddSheet" @close="() => { showAddSheet = false; getSheets(); }" />
        <confirm-delete v-if="showConfirmDelete" @confirm="deleteSheetCB" @cancel="() => { showConfirmDelete = false; }" msg="Are you sure you would like to delete this sheet?"/>
    </div>
</template>

<script lang="ts">
import { defineComponent, registerRuntimeCompiler } from 'vue';
import axios from 'axios';
import AddCompanySheet from '@/components/AddCompanySheet.vue';
import ConfirmDelete from '@/components/ConfirmDelete.vue';
import SelectEmployees from '@/components/SelectEmployees.vue';

export default defineComponent({
    name: 'CompanySheets',
    components: {
        AddCompanySheet,
        ConfirmDelete,
        SelectEmployees,
    },
    data() {
        return {
            allSheets: [] as any,
            sheets: [] as any,
            searchQ: '',
            showAddSheet: false,
            showConfirmDelete: false,
            slugToDelete: '',
            editUsersSlug: '',
            editUsersCurrent: [] as any,
            showEditUsers: false
        }
    },
    async created() {
        await this.getSheets();

        this.$store.state.routeLoaded = true;
    },
    methods: {
        async getSheets() {
            await axios.get(`${this.$store.state.apiUrl}/api/companysheets`)
                .then(resp => {
                    this.sheets = resp.data;
                    this.allSheets = resp.data;
                })
                .catch(e => {
                    console.log(e);
                })
        },
        deleteSheet(slug: string) {
            this.slugToDelete = slug;
            this.showConfirmDelete = true;
        },
        async deleteSheetCB() {
            await axios.delete(`${this.$store.state.apiUrl}/api/companysheets/${this.slugToDelete}`)
                .then(resp => {
                    this.getSheets();
                })
                .catch(e => {
                    alert('There was an error')
                    console.log(e);
                })
            
            this.showConfirmDelete = false;
        },
        search() {
            if(this.searchQ.length < 3) {
                this.sheets = this.allSheets;
            } else {
                const searchQLower = this.searchQ.toLowerCase();
                this.sheets = this.allSheets.filter((sheet: any) => {
                    return sheet.Name.toLowerCase().includes(searchQLower);
                })
            }
        },
        // Loads the employee IDs the sheet is shared with
        async editUsers(slug: string) {
            this.editUsersSlug = slug;
            await axios.get(`${this.$store.state.apiUrl}/api/companysheets/users/${slug}`)
                .then(resp => {
                    this.editUsersCurrent = resp.data;
                    this.showEditUsers = true;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        },
        async saveUsers(employeeIDs: number[]) {
            const data = {
                slug: this.editUsersSlug,
                employeeIDs
            }
            await axios.post(`${this.$store.state.apiUrl}/api/companysheets/users`, data)
                .then(() => {
                    this.showEditUsers = false;
                })
                .catch(e => {
                    alert('There was an error');
                    console.log(e);
                })
        }
    }
});
</script>
